(function() {
    const CartEvents = {
        add: "TLFREEGIFT:add",
        update: "TLFREEGIFT:update",
        change: "TLFREEGIFT:change",
        clear: "TLFREEGIFT:clear",
        mutate: "TLFREEGIFT:mutate",
    };

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;
        
        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }
    
    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch (e) {
                console.log("Error: ", e)
            }
        }

        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, {detail}));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, {detail}));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, {detail}));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, {detail}));
                break;
            default:
                break;
        }
    }

    async function getOtherPayItemData(originalData, parsedBody) {
        const lineItemData = parsedBody.variables?.input?.lines?.[0];
        const merchandiseId = lineItemData?.merchandiseId;
        const itemId = merchandiseId.split("/").pop();
        const itemDataRes = await window.tlFreeGiftOffer.storefrontApi.getVariantData(itemId);
        const itemData = itemDataRes?.node;

        const sellingPlanAllocation = originalData?.data?.result?.cart?.lines?.edges?.[0]?.node?.sellingPlanAllocation;
        return {
            id: itemId,
            price: parseFloat(itemData.price.amount) * window.tlFreeGiftOffer.currencyRate,
            quantity: lineItemData?.quantity ?? 1,
            productId: itemData.product.id.split("/").pop(),
            selling_plan: !!sellingPlanAllocation
        }
    }

    function hasSpecificCountryCondition(rule) {
        if (rule.advanced_conditions) {
            const advancedCondition = JSON.parse(rule.advanced_conditions);
            if (advancedCondition.specific_country) {
                return true
            }
        }

        return false;
    }

    async function processOtherPayGiftRules(originalData, parsedBody) {
        const giftLines = [];
        const discounts = [];
        const rules = window.tlFreeGiftOffer.rules;

        const currentItemsInCart = window.tlFreeGiftOffer.itemsInCart;
        const currentRuleIdMapGifts = window.tlFreeGiftOffer.ruleIdMapGifts;

        // fake itemsInOtherPay
        const itemsInOtherPayCart = new Map();
        const itemData = await getOtherPayItemData(originalData, parsedBody);
        itemsInOtherPayCart.set(itemData.id, itemData)

        // fake ruleIdMapGiftAddedByApp
        window.tlFreeGiftOffer.itemsInCart = itemsInOtherPayCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = new Map();
        
        let shouldPushLocation = false;
        for ( const rule of rules ) {
            if (rule.auto_add_gift) {
                const { needToAdd, giftsToAdd } = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                if(needToAdd){
                    for (const item of giftsToAdd) {
                        const giftLine = {
                            merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
                            quantity: item.quantity,
                            attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
                                key,
                                value: String(value)
                            }))
                        }
                        giftLines.push(giftLine);
                    }
                    discounts.push(rule.discount_code);
                }
            }

            if(hasSpecificCountryCondition(rule)) shouldPushLocation = true;
        }

        if (shouldPushLocation) {
            const { country, region } = await this.getIpInfo();
            
            if (!Array.isArray(parsedBody.variables.input.attributes)) {
                parsedBody.variables.input.attributes = [];
            }
            parsedBody.variables.input.attributes.push({
                key: window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE,
                value: `${country}-${region}`,
            });
        }

        parsedBody.variables.input.lines.push(...giftLines);
        parsedBody.variables.input.discountCodes = discounts;

        // Restore state before handling OtherPay 
        window.tlFreeGiftOffer.itemsInCart = currentItemsInCart;
        window.tlFreeGiftOffer.ruleIdMapGifts = currentRuleIdMapGifts;

        return parsedBody;
    }
 
    let tlFreeGiftOfferClone;
    let fetchClone = window.fetch;
    let updateTimer;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if(val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.updateCartData = async () => {
                    clearTimeout(updateTimer);

                    updateTimer = setTimeout(async () => {
                        try {
                            await window.tlFreeGiftOffer.detectCartData();

                            const { isUpdateCart, eligibleOtherRules } = await window.tlFreeGiftOffer.checkAllRule();

                            if(isUpdateCart){
                                // Prevent Reload
                                await window.tlFreeGiftOffer.refreshCartContent();
                            }else {
                                // Render
                                window.tlFreeGiftOffer.showPopupOffer(eligibleOtherRules)
                                window.tlFreeGiftOffer.showEmbedOffer();
                                if (window.tlGiftInCartWidget) {
                                    window.tlGiftInCartWidget.trackingCartDrawer();
                                }
                            }
                        } catch (error) {
                            console.log("Error when checkCartData: ", error);
                        }
                    }, 1500);
                }

                val.detectCartData = async () => {
                    try {
                        const cartData = await window.tlFreeGiftOffer.ajaxApi.cartGet();

                        const itemsInCart = new Map();
                        const ruleIdMapGifts = new Map();
                        if(cartData.items.length){
                            const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                            const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                            for (let i = 0; i < cartData.items.length; i++) {
                                const item = cartData.items[i];
                                const itemKey = item.key;
                                const itemId = String(item.id);
                                const productId = String(item.product_id);
            
                                const appliedRuleId = window.tlFreeGiftOffer.checkLineItemIsGift(item);

                                // If `appliedRuleId` is valid, the item is a gift
                                if(appliedRuleId){
                                    const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                                    ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                        id: itemId,
                                        key: itemKey,
                                        quantity: item.quantity,
                                        price: item.price / ratio,
                                        discounted_price: item.discounted_price / ratio // thêm field này
                                    }])
                                } else if(!window.tlFreeGiftOffer.utils.isOtherModuleGift(item)) {
                                    itemsInCart.set(itemKey, {
                                        id: itemId,
                                        price: item.price / ratio,
                                        discounted_price: item.discounted_price / ratio, // thêm field này
                                        quantity: item.quantity,
                                        title: item.title,
                                        image: item.image,
                                        productId: productId,
                                        selling_plan: !!item.selling_plan_allocation
                                    })
                                }
                            }
                        }

                        window.tlFreeGiftOffer.itemsInCart = new Map(itemsInCart);
                        window.tlFreeGiftOffer.ruleIdMapGifts = new Map(ruleIdMapGifts);
                        //Clear temp cart
                        window.tlFreeGiftOffer.itemsInTempCart.clear();
                        window.tlFreeGiftOffer.ruleIdMapGiftsInTempCart.clear();
                    } catch (error) {
                        console.log("Error when detectCartData: ", error);
                    }
                }

                val.getCustomerBuy = async (rule) => {
                    // Get a function to check if a cart item matches the rule's "apply_to_product" setting
                    const checkApllyTo = window.tlFreeGiftOffer.makeApplyToChecker(rule);

                    const parentInCart = [];
                    let totalProductApplied = 0;
                    let numberProductApplied = 0;

                    // Iterate through cart items to calculate totals for the rule
                    const items = window.tlFreeGiftOffer.getItems(rule);
                    for (let i = 0; i < items.length; i++) {
                        const [key, itemData] = items[i];
                        if(await checkApllyTo(itemData) && window.tlFreeGiftOffer.checkPurchaseType(itemData, rule.purchase_type)){
                            numberProductApplied += itemData.quantity;
                            totalProductApplied += itemData.discounted_price * itemData.quantity; // tính theo discounted price thay vì price

                            parentInCart.push({key, ...itemData})
                        }
                    }
                    
                    return {parentInCart, totalProductApplied, numberProductApplied}
                }

                val.refreshCartContent = async () => {
                    if (window.location.pathname === '/cart') {
                        window.location.reload();
                    } else {
                        ajaxCart.load();
                    }
                }
                Object.defineProperty(window, "fetch", {
                    get() {
                        return fetchClone;
                    },
                    set(val) {
                        if(val.toString().includes("X-Start-Wallet-Checkout")) {
                            const originalFetch = window.fetch;
                            val = async function () {
                                const [resource, config] = [...arguments];

                                const headers = config?.headers || {};
                                const isOtherCreateCart = headers["X-Start-Wallet-Checkout"] === "true" && ["ShopPay", "BuyItNow"].includes(headers["X-Wallet-Name"]);
                                if(isOtherCreateCart){
                                    try {
                                        const parsedBody = JSON.parse(config.body);
                                        const isCartCreate = parsedBody.query?.includes("mutation cartCreate") && Array.isArray(parsedBody.variables?.input?.lines);

                                        if (!isCartCreate) {
                                            return originalFetch.apply(this, arguments);
                                        }
                                        const originalResponse = await originalFetch.apply(this, arguments);
                                        const cloneRes = originalResponse.clone();
                                        const originalData = await cloneRes.json();

                                        const newBody = await processOtherPayGiftRules(originalData, parsedBody);
                                        config.body = JSON.stringify(newBody);
                                    } catch (error) {
                                        console.error("Error injecting gift into OtherPay cartCreate:", error);
                                    }
                                    return originalFetch.apply(this, arguments);
                                }else if (isShopifyCartURL(resource) && config && config.body && config.body !== "{}") {
                                    window.tlFreeGiftOffer.cartHasChanged = true;
                                    const response = originalFetch.apply(this, arguments)

                                    response.then((res) => {
                                        res
                                            .clone()
                                            .json()
                                            .then((data) => window.tlFreeGiftOffer.updateCartData());
                                    });
                                    return response;
                                } else {
                                    return originalFetch(...arguments)
                                }
                            };

                            
                        }
                        fetchClone = val;
                    },
                    configurable: true
                });   
            }
        },
        configurable: true
    });
    
})();